export const SUCCESS_NOTIFICATION_DISPLAY_DURATION = 2000;
export const ERROR_NOTIFICATION_DISPLAY_DURATION = 2000;
